import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "state_box" }
const _hoisted_2 = { class: "d_f jc_sb state_signing_status" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "state_list" }
const _hoisted_5 = { class: "f_1" }
const _hoisted_6 = { class: "d_f jc_sb" }
const _hoisted_7 = { class: "state_item_state" }
const _hoisted_8 = { class: "state_item_time" }
const _hoisted_9 = { class: "state_item_name" }
const _hoisted_10 = {
  key: 0,
  class: "state_item_remark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "流程", -1)),
      (_ctx.signingStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "签约状态：" + _toDisplayString(_ctx.signingStatus), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestStateList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "d_f ai_fs state_item",
          key: index
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            class: "state_item_img",
            src: "https://images.goworkla.cn/wxAppletImg/portrait.png"
          }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.stateStr), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.state_time), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.state_accountname || ''), 1),
            ([5, 6, 7, 8].some(v => item.agreement_state === v))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.remark || ''), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}